var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41121 16.3788C7.23171 16.3788 7.05222 16.3127 6.91051 16.171L0.75104 10.0115C-0.250347 9.0101 -0.250347 7.36632 0.75104 6.36493L6.91051 0.205473C7.18448 -0.0684911 7.63794 -0.0684911 7.9119 0.205473C8.18587 0.479438 8.18587 0.932896 7.9119 1.20686L1.75243 7.36632C1.29897 7.81977 1.29897 8.55664 1.75243 9.0101L7.9119 15.1696C8.18587 15.4435 8.18587 15.897 7.9119 16.171C7.7702 16.3032 7.5907 16.3788 7.41121 16.3788Z",
    fill: "#919191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3608 16.3788C15.1813 16.3788 15.0018 16.3127 14.8601 16.171C14.5861 15.897 14.5861 15.4435 14.8601 15.1696L21.0195 9.0101C21.473 8.55664 21.473 7.81977 21.0195 7.36632L14.8601 1.20686C14.5861 0.932896 14.5861 0.479438 14.8601 0.205473C15.134 -0.0684911 15.5875 -0.0684911 15.8615 0.205473L22.0209 6.36493C22.5027 6.84673 22.7767 7.49858 22.7767 8.18821C22.7767 8.87784 22.5122 9.52969 22.0209 10.0115L15.8615 16.171C15.7198 16.3032 15.5403 16.3788 15.3608 16.3788Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/Code.adb808d497245f86af400caf04c58939.svg";
export { ForwardRef as ReactComponent };